import React, { useState } from 'react';
import GridtyLogo from '/src/assets/logos/gridty_logo.svg';
import LeonhardWeissLogo from '/src/assets/logos/leonhard-weiss.svg';
import { VITE_NODE_ENV } from '@/utils/getEnv';
import { HamLogo } from '../logos/HamLogo';
import { CategoryItem } from '@/shared/MainContainer';
import { createPortal } from 'react-dom';
import { Sidebar } from '../Sidebar/Sidebar';
import LeonovaLogo from '/src/assets/logos/leonova.svg';

const clientLogos = {
  'leonhard-weiss': LeonhardWeissLogo,
  gridty: GridtyLogo,
  leonova: LeonovaLogo,
};

const logo = VITE_NODE_ENV['VITE_THEME'] as keyof typeof clientLogos;

export const MobileNavbar = ({
  page,
  pages,
  formValues,
}: {
  page: string;
  pages: CategoryItem[];
  formValues: Record<string, any>;
}) => {
  const [open, setOpen] = useState(false);
  const allQuestions = pages
    .flatMap(cat => cat.qns)
    .filter((q, index, self) => index === self.findIndex(q2 => q2.title === q.title));
  const currentStepIndex = allQuestions.findIndex(q => q.title === page);
  const currentStep = currentStepIndex >= 0 ? currentStepIndex + 1 : 1;
  const percent = Math.round((currentStep / allQuestions.length) * 100);
  return (
    <div className="bg-secondary">
      <div className="flex justify-start items-center w-full px-[16px] py-[12px] border-b border-[#525255]">
        <img src={clientLogos[logo]} alt="logo" />
      </div>
      <div className="flex items-center gap-[16px] px-[16px] py-[20px]">
        <div onClick={() => setOpen(true)} style={{ cursor: 'pointer' }}>
          <HamLogo />
        </div>
        <div className="w-[300px]">
          <h3 className="text-[16px] font-semibold text-primary">
            Step {currentStep} / {pages.length}: {page}
          </h3>
          <div className="flex items-center gap-[12px]">
            <input
              type="range"
              min={0}
              max={100}
              value={percent}
              className={`w-full`}
              readOnly
              style={{
                background: `linear-gradient(to right, var(--slider-color) ${percent}%, #ffffff ${percent}%)`,
              }}
            />
            <p className="text-[14px] text-primary">{`${percent}%`}</p>
          </div>
        </div>
      </div>
      {open &&
        createPortal(
          <div>
            {/* Backdrop */}
            <div
              // style={{ zIndex: 1200 }}
              className="fixed inset-0 bg-black !z-[9999] bg-opacity-30"
              onClick={() => setOpen(false)}
            />
            {/* Sidebar/modal */}
            <div
              className="fixed left-0 top-0 h-full w-[300px] bg-secondary !z-[10000] shadow-lg flex flex-col"
              onClick={e => e.stopPropagation()} // Prevent immediate close when clicking inside modal
              style={{ transition: 'transform 0.3s' }}
            >
              {/* Modal content here, e.g., your onboarding menu */}
              <Sidebar pages={pages} page={page} formValues={formValues} />
              {/* You can add a close button (optional) */}
              <button
                onClick={() => setOpen(false)}
                className="absolute top-4 right-4 text-white text-2xl"
                aria-label="Close"
              >
                &times;
              </button>
            </div>
          </div>,
          document.body,
        )}
    </div>
  );
};
